"use client"
import { setReferralTrackingParameter } from "@opensea/analytics"
import { useCookie, useIsHydrated } from "@opensea/ui-kit/hooks"
import { useEffect } from "react"

const REFERRAL_COOKIE_NAME = "os_ref_code"
const REFERRAL_COOKIE_EXPIRATION = 7 // 7 days (7 * 24 hours)

// Regex for validating referral code format (alphanumeric, underscores, and hyphens only)
const REFERRAL_CODE_FORMAT_REGEX = /^[a-zA-Z0-9_-]+$/

export function useReferralParam() {
  const [referralCode, setReferralCode] = useCookie(REFERRAL_COOKIE_NAME)
  const isHydrated = useIsHydrated()

  useEffect(() => {
    if (!isHydrated) {
      return
    }

    try {
      const searchParams = new URLSearchParams(window.location.search)
      const osRef = searchParams.get("os_ref")
      if (
        osRef?.trim() &&
        REFERRAL_CODE_FORMAT_REGEX.test(osRef) &&
        osRef.length <= 50
      ) {
        setReferralCode(osRef, {
          expires: REFERRAL_COOKIE_EXPIRATION,
          secure: true,
          sameSite: "strict",
        })
      }
    } catch (error) {
      console.warn("Failed to parse URL parameters for referral code:", error)
    }
  }, [isHydrated, setReferralCode])

  useEffect(() => {
    setReferralTrackingParameter(referralCode ?? undefined)
  }, [referralCode])

  return { referralCode }
}
